import { render, staticRenderFns } from "./ProjectListingCNI.vue?vue&type=template&id=27db83e6&"
import script from "./ProjectListingCNI.vue?vue&type=script&lang=js&"
export * from "./ProjectListingCNI.vue?vue&type=script&lang=js&"
import style0 from "./ProjectListingCNI.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports